import styled from 'styled-components';

export const Container = styled.div`
  min-height: 100vh;
  display: flex;
  gap: 1rem;
  flex-direction: column;
  padding: 2rem;

  h1 {
    font-size: 30px;
    color: ${({ theme }) => theme.colors.secondary};
    font-weight: 450;
  }

  @media (max-width: 450px) {
    padding: 1rem;
  }
`;

export const Body = styled.div`
  background: ${({ theme }) => theme.colors.background};
`;

export const Content = styled.div`
  width: 100%;
  height: 100%;
  margin-top: 5rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  .buttonDiv {
    display: flex;
    justify-content: center;
    width: 100%;

    button {
      margin-top: 1rem;
      width: 13rem;
      height: 2.3rem;
      border: 1px solid ${({ theme }) => theme.colors.primary};
      border-radius: 2rem;
      color: ${({ theme }) => theme.colors.primary};
      background: transparent;
      font-size: 21px;
      font-weight: 300;
      margin-left: 17rem;

      &:hover {
        color: ${({ theme }) => theme.colors.background};
        background: ${({ theme }) => theme.colors.primary};
        cursor: pointer;
      }
    }
  }

  @media (max-width: 450px) {
    gap: 2rem;

    .buttonDiv button {
      margin-left: 0rem;
    }
  }

  @media (max-width: 300px) {
    .buttonDiv button {
      width: 100%;
    }
  }
`;

export const Form = styled.form`
  display: flex;
  align-self: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  max-width: 28rem;
  max-height: 10rem;
  border-radius: 1rem;
  padding: 2rem;
  box-shadow: 3px 3px 6px #00000029;
  background-color: ${({ theme }) => theme.colors.background_white};

  .header {
    display: flex;
    align-items: center;

    svg {
      fill: ${({ theme }) => theme.colors.secondary};
      width: 1.8rem;
      height: 1.8rem;
      margin-right: 1rem;
    }

    p {
      color: ${({ theme }) => theme.colors.secondary};
      font-size: 22px;
      font-weight: 300;
    }
  }

  .contentGrid {
    display: flex;
    flex-direction: column;
    gap: 4rem;
  }

  .optionUser {
    display: flex;
    align-items: center;
    margin-top: -3rem;

    svg {
      fill: ${({ theme }) => theme.colors.secondary};
    }

    .MuiButtonBase-root {
      font-family: 'Futura PT' !important;
    }

    .MuiInputBase-root {
      color: ${({ theme }) => theme.colors.primary}!important;
      border: none;
    }

    .MuiInputBase-root {
      font-family: 'Futura PT' !important;
      font-weight: 300;
    }

    .select-style {
      width: 100%;
      height: 1rem;
      padding: 0.5rem;
      font-size: 1rem;
      position: relative;
    }

    .MuiOutlinedInput-notchedOutline {
      border: none;
      border-bottom: 1px ${({ theme }) => theme.colors.text} solid;
      border-radius: unset;
    }

    .MuiMenuItem-root li {
      font-size: 1rem;
    }
  }

  @media (max-width: 450px) {
    padding: 1rem;
  }
`;
